import React from 'react';
import styled from 'styled-components';
import Stars from '@zocdoc-frontend-common/components-stars';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { grey75 } from '@zocdoc/branding/colors';

const DoctorRating = ({ className, provider = {}, style }) => {
    const { averageRating, optOutOfRatings, reviewCount } = provider;

    return (
        <DoctorRatingDiv
            className={className}
            data-test="lightweight-doctor-card-rating"
            style={style}
        >
            {!optOutOfRatings && reviewCount > 0 ? (
                <>
                    <Stars
                        rating={averageRating}
                        data-test="lightweight-doctor-card-stars"
                    />
                    <DoctorCardReviewCount data-test="lightweight-doctor-card-review-count">
                        ({parseInt(reviewCount, 10).toString() || reviewCount})
                    </DoctorCardReviewCount>
                </>
            ) : (
                <NoReviewText data-test="lightweight-doctor-card-no-review-text">
                    No reviews
                </NoReviewText>
            )}
        </DoctorRatingDiv>
    );
};

const DoctorRatingDiv = styled.div`
    display: flex;
    align-items: center;
    margin-top: 4px;
`;

const DoctorCardReviewCount = styled.div`
    color: ${grey75};
    font: 12px ${FontFamily.SharpSansSemibold};
    line-height: 12px;
    margin-left: 5px;
`;

const NoReviewText = styled.div`
    color: ${grey75};
    font: 13px ${FontFamily.SharpSansSemibold};
    line-height: 12px;
`;

export default DoctorRating;
